import type { RoleTemplate } from 'schemas';
import type { EntityCardProps } from '@/components/EntityCard';

/**
 * Transforms role template data to EntityCard component props
 * @param roleTemplate - Role template from the API
 * @returns Props object for EntityCard component
 */
export const transformRoleTemplateToEntityCard = (
  roleTemplate: RoleTemplate
): EntityCardProps => {
  return {
    title: roleTemplate.title,
    description: roleTemplate.description,
    imageUrls: undefined,
    imageAlt: roleTemplate.title,
  };
};
